import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { UUID } from '@/types';
import Column from '@/util/Column';
import TableRef from '@/util/TableRef';
import TovBuilder from '../../util/TovBuilder';

export type Aliases = Record<string, TableRef>;

export type GetQueryColumnsResult = {
  queryColumns: Column[];
  aliases: Aliases;
};

const mapAliases = (object: Aliases) => {
  return Object.keys(object).reduce((acc: Aliases, key: string) => {
    // @ts-expect-error: types mismatch.
    acc[key] = TovBuilder.build(object[key]);
    return acc;
  }, {});
};

export const queryColumnsApi = createApi({
  reducerPath: 'queryColumnsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
  }),
  endpoints: (builder) => ({
    getQueryColumns: builder.query<
      GetQueryColumnsResult,
      { datasourceId: UUID; seriesId: UUID }
    >({
      query: ({ datasourceId, seriesId }) =>
        `datasources/${datasourceId}/dashboards/query-columns/${seriesId}`,
      transformResponse: (response: GetQueryColumnsResult) => {
        return {
          queryColumns: response.queryColumns.map((q: Column) =>
            Column.build(q),
          ),
          aliases: mapAliases(response.aliases),
        };
      },
    }),
  }),
});

export const { useGetQueryColumnsQuery } = queryColumnsApi;
